export default "__VITE_ASSET__CCaBUDTK__"